<div class="container">
  <div class="row">
    <div style="height: 50px"></div>
  </div>
  <div>
    <img class="img" src="../assets/img/header-bg.jpg" alt="" >
  </div>
 
  <div class="row" id="footer"></div>
</div>
